<template>
  
<div @mouseover="showBlock = true" @mouseleave="showBlock = false" @touchstart="showBlock = true" @touchend="showBlock = false" class="relative">
    <div class="d-lg-block d-none artwork position-relative">
      <a :href="product.permalink" class="">
        <div v-if="!product.is_in_stock" class="product-thumbnail-ribbon product-thumbnail-ribbon-top-left"><span>Sold</span></div>
        <div class="product-img" v-html="product.image"></div>
        
        <div class="position-absolute px-3 pt-4 pb-2 w-100 bottom-0 bg-darker bg-opacity-75 text-white">
            <h5>{{product.title}}</h5>
            <div class="mb-2">£{{product.price}}</div>
            <div class="mt-2 mb-2">{{product.artist_name}}</div>
        </div>
      </a>
  </div>
  <div class="d-lg-none d-block my-4">
    <a  data-bs-toggle="offcanvas" :data-bs-target="'#product-offcanvas-' + product.id">
      <div aria-controls="offcanvasBottom" class="product-img" v-html="product.image"></div>
    </a>
    
    <div class="offcanvas offcanvas-bottom bg-darker bg-opacity-75 text-white" tabindex="-1" :id="'product-offcanvas-' + product.id" :aria-labelledby="'product-offcanvas-label-' + product.id">
      <div class="offcanvas-header opacity-100">
        
        <h3 class="text-lg mdbolder">{{product.title}}</h3>
        <button type="button" class="btn-close btn-close-white text-reset text-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body large opacity-100">
          <div>
          <h5 class="text-lg">£{{product.price}}</h5>
          <h5 class="text-lg">{{product.artist_name}}</h5>
          <a :href="product.permalink" class="btn btn-outline-light mt-2"> MORE INFO</a> 
          </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import axios from 'axios'
export default {
    name: 'product',
    props: ['product'],
    data() {
        return {
            page: 1,
            products : [],
            showBlock: false,
        }
    },

    mounted() {
    },
}
</script>

<style>

</style>